import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component - resets scroll position on route change
 * Per UX expert consensus: persisted scroll position breaks mental model
 * and trust in content-heavy services.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
